import React, { useEffect, useState } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import YatHandLoader from '@pkg/components/YatHandLoader';

import { BoldText, Text } from '../YatMintFlow.style';

import { LoaderHolder, LoadingStepWrapper, StepContentWrapper } from './MintingSteps.style';

export function LoadingMint() {
    const { t } = useTranslation(['nft']);
    const [loadingText, setLoadingText] = useState<string>('minting_loading_text');

    useEffect(() => {
        const textTimer = setTimeout(
            () => {
                setLoadingText('minting_loading_overtime_text');
            },
            2 * 20 * 1000,
        );
        return () => {
            clearTimeout(textTimer);
        };
    }, []);

    return (
        <LoadingStepWrapper>
            <StepContentWrapper>
                <LoaderHolder>
                    <YatHandLoader />
                </LoaderHolder>
                <BoldText>{t('minting_loading_title', { item: t('translation:yat') })}</BoldText>
                <Text>
                    <Trans ns="nft" i18nKey={loadingText}>
                        <span>0</span>
                    </Trans>
                </Text>
            </StepContentWrapper>
        </LoadingStepWrapper>
    );
}

export function Loading() {
    return (
        <LoadingStepWrapper>
            <LoaderHolder>
                <YatHandLoader />
            </LoaderHolder>
        </LoadingStepWrapper>
    );
}
